document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".vijay-notify-wrapper").forEach(wrapper => {

    const toggleBtn = wrapper.querySelector(".notify-toggle-btn");
    const form = wrapper.querySelector(".notify-me-form");
    const success = wrapper.querySelector(".notify-success");

    toggleBtn.addEventListener("click", () => {
      form.style.display = "block";
      toggleBtn.style.display = "none";
    });

    form.addEventListener("submit", async (e) => {
      e.preventDefault();

      const formData = new FormData(form);

      await fetch("/apps/flow/notify-me", {
        method: "POST",
        body: formData
      });

      form.style.display = "none";
      success.style.display = "block";
      success.style.color = "#28a745";
      success.style.fontWeight = "600";
    });
  });
});
